const categoryMapping = {
  blueprintsKitsRecipes: "Industry",
  interiorDecorations: "Decoration",
  exteriorDecorations: "Decoration",
  cds: "CDs",
  decor: "Decoration",
  tools: "Tools",
  consumables: "Consumable",
  consumable: "Consumable",
  pets: "Pet Items",
  crafting: "Crafting",
  farming: "Farming",
  specialty: "Specialty",
  general: "General",
  "drink/food": "Consumable",
  industry: "Industry",
  utility: "Utility",
  wallpaper: "Wall Decor",
  bedcover: "Bedding",
  wearable: "Clothing",
  flooring: "Flooring",
  glowstick: "Glowstick",
  decoration: "Decoration",
  storage: "Utility",
  wardrobe: "Asset Skins",
  event: "Event Items",
  disc: "Discoverability",
  skins: "Asset Skins",
  winery: "Winery",
  miscellaneous: "Misc",
  spacebbq: "Galactic Grill",
  stoneshaping: "Stoneshaping",
  landbbq: "Barney's BBQ",
  cooking: "Cooking",
  waterbbq: "Submarine Sizzler",
  woodwork: "Woodworking",
  metalworking: "Metalworking",
  machine: "The Machine",
  windmill: "Windmill",
  industries: "Ministry of Innovation",
  textile_mill: "Textiler",
  shake: "Milkshake Machine",
  compost: "Composter",
  juicer: "Shorelime Juicer",
  coffee: "Latte Machine",
  quantum_recombinator: "Quantum Recombinator",
  moca: "Mocaverse Clubhouse",
  moca2: "Mocaverse Crafting Table",
  gemcutting: "Gem Cutting (Not available yet)",
  sweater: "Pixmas Textiling",
  boost: "Industry Boosts",
};

const currencyMapping = {
  cur_coins: "Coins",
  cur_pixel: "$PIXEL",
  cur_cyber: "$CYBER",
  cur_nana: "$NANA",
  cur_pepe: "$PEPE",
  cur_other: "$Other",
  cur_polygon_berry: "Polygon Berry",
  cur_wron: "$WRON",
  cur_ape: "$APE",
  cur_teeth: "Teeth",
  cur_chain: "PixTix",
  cur_mistletoe: "Red Mistletokens",
  cur_mistletoe_green: "Green Mistletokens",
  cur_mistletoe_white: "White Mistletokens",
  cur_guildtoken: "Guild Runes",
};

const itemsToExclude = [
  "itm_yawnionSeeds",
  "itm_joybeanSeeds",
  "itm_baycSeeds",
  "itm_abomSeeds",
  "itm_perfectPopberrySeeds",
  "itm_mushroomSeeds_01",
  "itm_mushroomSeeds_02",
  "itm_mushroomSeeds_03",
  "itm_mushroomSeeds_04",
  "itm_goldenPopberrySeeds",
  "itm_goldenPopberrySeeds",
  "itm_60dayflower_seed",
  "itm_shorelimeSeeds",
  "itm_woolyweedSeeds",
  "itm_yarnyamSeeds",
  "itm_pot_goldclover",
  "itm_pixelplumSeeds",
  "itm_luckySeed",
  "itm_runningShoe_basic",
  "itm_yggSeed",
  "itm_gem_01",
  "itm_pet_treats_12pack",
  "ach_slughutch_kit_02",
  "ach_slughutch_kit_03",
  "ach_slughutch_kit_04",
  "ach_slughutch_kit_05",
  "ach_pet_treats_12pack",
  "ach_Popberry_Pie_TEST",
  "ach_watertest",
  "ach_runningShoe_basic",
  "ach_jam_popberry_tutorial",
  "ach_xmas_toy_24_01",
  "ach_xmasUgly_24_01",
  "ach_xmasUgly_24_02",
  "ach_xmasUgly_24_03",
  "ach_xmasUgly_24_04",
  "ach_bento_01_public",
  "ach_fluffgrice_public"
];

const industryMapping = {
  winery: "Winery",
  miscellaneous: "Misc",
  spacebbq: "Galactic Grill",
  stoneshaping: "Stoneshaping",
  landbbq: "Barney's BBQ",
  cooking: "Cooking",
  waterbbq: "Submarine Sizzler",
  woodwork: "Woodworking",
  metalworking: "Metalworking",
  machine: "The Machine",
  windmill: "Windmill",
  farming: "Farming",
  industries: "Not Craftable",
  textile_mill: "Textiler",
  shake: "Milkshake Machine",
  compost: "Composter",
  juicer: "Shorelime Juicer",
  coffee: "Latte Machine",
  quantum_recombinator: "Quantum Recombinator",
  moca: "Mocaverse Clubhouse",
  moca2: "Mocaverse Crafting Table",
  gemcutting: "Gem Cutting (Not available yet)",
  cookboxing: "Cooking Boxes",
  mineboxing: "Mining Boxes",
  businessboxing: "Business Boxes",
  metalboxing: "Metalworking Boxes",
  stoneboxing: "Stoneshaping Boxes",
  forestboxing: "Forestry Boxes",
  animalboxing: "Animal Care Boxes",
  farmboxing: "Farming Boxes",
  woodboxing: "Woodworking Boxes",
  business: "Business",
  petcare: "Animal Care",
  lantern: "Misc",
  mining: "Mining",
  forestry: "Forestry",
  exploration: "Exploration",
  sushi: "Sushi Kit",
};

const entityMap = {
  Boosts: {
    ent_bstB01: { name: "Farming Ice Sculpture" },
    ent_bstB02: { name: "Forestry Ice Sculpture" },
    ent_bstB03: { name: "Mining Ice Sculpture" },
    ent_bstB04: { name: "Coop Ice Sculpture" },
    ent_bstB05: { name: "Slug Hutch Ice Sculpture" },
    ent_bstB06: { name: "Apiary Ice Sculpture" },
    ent_bstB07: { name: "Mill Ice Sculpture" },
    ent_bstB08: { name: "Cooking Ice Sculpture" },
    ent_bstB09: { name: "Woodworking Ice Sculpture" },
    ent_bstB10: { name: "Stoneshaping Ice Sculpture" },
    ent_bstB11: { name: "Metalworking Ice Sculpture" },
    ent_bstB12: { name: "Winemaking Ice Sculpture" },
    ent_bstB13: { name: "Textilemaking Ice Sculpture" },
    ent_bstB14: { name: "BBQ Ice Sculpture" },
    ent_bstB15: { name: "Golden Snake Sculpture" },
    ent_bstB16: { name: "Red Snake Sculpture" },
    ent_cloverbst1: { name: "Sham Rock-Mining Sculpture" },
    ent_cloverbst2: { name: "Double Rainbow Mining Sculpture" },
    ent_scarecrowbst1: { name: "Scaregrow Sculpture" },
    ent_scarecrowbst2: { name: "Scaregrowier Sculpture" },
    ent_bstA07: { name: "Animal Care Tiki Sculpture" },
    ent_bstA06: { name: "Apiary Tiki Sculpture" },
    ent_bstA05: { name: "Slug Hutch Tiki Sculpture" },
    ent_bstA04: { name: "Coop Tiki Sculpture" },
    ent_bstA03: { name: "Mining Tiki Sculpture" },
    ent_bstA02: { name: "Forestry Tiki Sculpture" },
    ent_bstA01: { name: "Farming Tiki Sculpture" },
  },
  Other: {
    ent_saunaportal: { name: "Sauna Portal" },
    ent_neonzoneportal: { name: "Neon Zone Portal" },
    ent_barneys_barn_door: { name: "Barney's Door" },
    ent_pierPortal: { name: "Pier Portal" },
  },
  Untiered: {
    ent_windmill: { name: "Windmill" },
    ent_coop: { name: "Coop" },
    ent_allcrops: { name: "Soil" },
    ent_sluggery: { name: "Slug Hutch" },
    ent_textile: { name: "Textile Mill" },
    ent_apiary: { name: "Apiary" },
    ent_turkey: { name: "Turkey" },
    ent_cow_pickup: { name: "Cow" },
    ent_sheep_01: { name: "Sheep" },
    ent_planter_soil: { name: "Indoor Planters" },
    ent_waterbbq: { name: "Submarine Sizzler" },
    ent_landbbq: { name: "Barneys BBQ" },
    ent_science: { name: "Potions Table" },
    ent_spacebbq: { name: "Galactic Grill" },
    ent_speicial_mine: { name: "Special Mine (Bog)" },
    ent_speicial_mine_2: { name: "Special Mine (Crystal)" },
    ent_speicial_mine_3: { name: "Special Mine (Mystic)" },
    ent_speicial_mine_4: { name: "Special Mine (Sky)" },
    ent_speicial_mine_5: { name: "Special Mine (Steppes)" },
    ent_fishing_space: { name: "Fishing Pond" },
    ent_fishing_water: { name: "Fishing Pond" },
    ent_fishing_grass: { name: "Fishing Pond" },
  },
  T1: {
    ent_mine_01: { name: "Mine" },
    ent_treeLand1v1: { name: "Tree" },
    ent_treeLand1v2: { name: "Tree" },
    ent_treeLand1v3: { name: "Tree" },
    ent_treeWater1v1: { name: "Tree" },
    ent_treeWater1v2: { name: "Tree" },
    ent_treeWater1v3: { name: "Tree" },
    ent_treeSpace1v1: { name: "Tree" },
    ent_treeSpace1v2: { name: "Tree" },
    ent_treeSpace1v3: { name: "Tree" },
    ent_stove: { name: "Stove" },
    ent_metalworking_01: { name: "Metalworking" },
    ent_kiln_01: { name: "Stoneshaping" },
    ent_woodwork_01: { name: "WW Bench" },
    ent_winery_01: { name: "Winery" },
    ent_sushi_kit_01: { name: "Sushi Kit" },
  },
  T2: {
    ent_mine_02: { name: "Mine" },
    ent_treeLand2v1: { name: "Tree" },
    ent_treeLand2v2: { name: "Tree" },
    ent_treeLand2v3: { name: "Tree" },
    ent_treeWater2v1: { name: "Tree" },
    ent_treeWater2v2: { name: "Tree" },
    ent_treeWater2v3: { name: "Tree" },
    ent_treeSpace2v1: { name: "Tree" },
    ent_treeSpace2v2: { name: "Tree" },
    ent_treeSpace2v3: { name: "Tree" },
    ent_stove_02: { name: "Stove" },
    ent_metalworking_02: { name: "Metalworking" },
    ent_kiln_02: { name: "Stoneshaping" },
    ent_woodwork_02: { name: "WW Bench" },
    ent_winery_02: { name: "Winery" },
    ent_sushi_kit_02: { name: "Sushi Kit" },
  },
  T3: {
    ent_mine_03: { name: "Mine" },
    ent_treeLand3v1: { name: "Tree" },
    ent_treeLand3v2: { name: "Tree" },
    ent_treeLand3v3: { name: "Tree" },
    ent_treeWater3v1: { name: "Tree" },
    ent_treeWater3v2: { name: "Tree" },
    ent_treeWater3v3: { name: "Tree" },
    ent_treeSpace3v1: { name: "Tree" },
    ent_treeSpace3v2: { name: "Tree" },
    ent_treeSpace3v3: { name: "Tree" },
    ent_stove_03: { name: "Stove" },
    ent_metalworking_03: { name: "Metalworking" },
    ent_kiln_03: { name: "Stoneshaping" },
    ent_woodwork_03: { name: "WW Bench" },
    ent_winery_03: { name: "Winery" },
    ent_sushi_kit_03: { name: "Sushi Kit" },
  },
  T4: {
    ent_mine_04: { name: "Mine" },
    ent_treeLand4v1: { name: "Tree" },
    ent_treeLand4v2: { name: "Tree" },
    ent_treeLand4v3: { name: "Tree" },
    ent_treeWater4v1: { name: "Tree" },
    ent_treeWater4v2: { name: "Tree" },
    ent_treeWater4v3: { name: "Tree" },
    ent_treeSpace4v1: { name: "Tree" },
    ent_treeSpace4v2: { name: "Tree" },
    ent_treeSpace4v3: { name: "Tree" },
    ent_stove_04: { name: "Stove" },
    ent_winery: { name: "Winery" },
    ent_metalworking_04: { name: "Metalworking" },
    ent_kiln_04: { name: "Stoneshaping" },
    ent_woodwork_04: { name: "WW Bench" },
    ent_sushi_kit_04: { name: "Sushi Kit" },
  },
  T5: {
    ent_mine_05: { name: "Mine" },
    ent_treeLand5v1: { name: "Tree" },
    ent_treeLand5v2: { name: "Tree" },
    ent_treeLand5v3: { name: "Tree" },
    ent_treeWater5v1: { name: "Tree" },
    ent_treeWater5v2: { name: "Tree" },
    ent_treeWater5v3: { name: "Tree" },
    ent_treeSpace5v1: { name: "Tree" },
    ent_treeSpace5v2: { name: "Tree" },
    ent_treeSpace5v3: { name: "Tree" },
    ent_stove_05: { name: "Stove" },
    ent_metalworking_05: { name: "Metalworking" },
    ent_kiln_05: { name: "Stoneshaping" },
    ent_woodwork_05: { name: "WW Bench" },
  },
};

export { categoryMapping, currencyMapping, itemsToExclude, industryMapping, entityMap };
